import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punedarshantempotraveller() {



    const cardData = {

keyword: "Pune Darshan Tempo Traveller on Rent",

headingDescription:
    "Rising Cab Service offers comfortable Pune Darshan Tempo Traveller on Rent services for families, tourist groups, corporate outings, and pilgrimage travelers. Our spacious Tempo Travellers are ideal for group sightseeing in Pune, providing ample seating, push-back seats, air-conditioned comfort, and experienced drivers who know all major city attractions. We offer flexible half-day and full-day Pune Darshan packages with customizable routes covering historical monuments, temples, gardens, and museums. With 24/7 availability, affordable pricing, and well-maintained vehicles, Rising Cab Service ensures a safe, smooth, and enjoyable group travel experience across Pune.",

topPlaces: [
  
    {
        title: "Dagadusheth Halwai Ganpati Temple",
        description:
            "Dagadusheth Halwai Ganpati Temple is one of Pune’s most revered temples dedicated to Lord Ganesha. The beautifully decorated idol attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes a major cultural and spiritual attraction with grand celebrations."
    },
    {
        title: "Sinhagad Fort",
        description:
            "Sinhagad Fort is a historic hill fort located on the Sahyadri ranges, known for the legendary battle of Tanaji Malusare. It offers panoramic views, trekking trails, and local Maharashtrian food stalls, making it a perfect mix of history and adventure."
    },
    {
        title: "Raja Dinkar Kelkar Museum",
        description:
            "Raja Dinkar Kelkar Museum houses a vast collection of Indian artifacts including sculptures, musical instruments, weapons, and traditional household items. It provides a deep insight into India’s cultural heritage and artistic excellence across centuries."
    },
      {
        title: "Shaniwar Wada",
        description:
            "Shaniwar Wada is Pune’s most famous historical fort and a major attraction included in almost every city tour. Built by the Peshwas in the 18th century, it showcases grand gates, strong stone walls, and remnants of royal architecture. The evening light and sound show narrates the rich Maratha history, making it a must-visit stop in Pune Darshan."
    },
    {
        title: "Aga Khan Palace",
        description:
            "Aga Khan Palace is a significant landmark of India’s freedom struggle, where Mahatma Gandhi and other leaders were once imprisoned. The palace is known for its elegant architecture, peaceful gardens, and museum displaying historical photographs and personal belongings of freedom fighters."
    },
    {
        title: "Parvati Hill Temple",
        description:
            "Parvati Hill Temple is one of Pune’s oldest heritage sites, offering panoramic views of the city. The hill hosts ancient temples dedicated to Lord Shiva and other deities. It is a peaceful spiritual destination combined with light trekking."
    },
    {
        title: "Pataleshwar Cave Temple",
        description:
            "Pataleshwar Cave Temple is an 8th-century rock-cut temple dedicated to Lord Shiva. Carved from a single basalt rock, it features impressive pillars and a calm spiritual atmosphere right in the heart of Pune city."
    },
    {
        title: "Saras Baug",
        description:
            "Saras Baug is a beautiful garden known for its greenery and the Siddhivinayak Temple located at its center. It is a popular relaxing spot for families and tourists visiting Pune for sightseeing and evening walks."
    },
    {
        title: "Khadakwasla Dam",
        description:
            "Khadakwasla Dam is a scenic picnic spot near Pune, famous for its calm waters and beautiful surroundings. It is especially popular during monsoon when the area turns lush green and attracts large crowds for weekend outings."
    },
    {
        title: "Empress Garden",
        description:
            "Empress Garden is a well-maintained botanical garden in Pune featuring a wide variety of flowers, plants, and walking paths. It is a peaceful attraction ideal for families, nature lovers, and photography enthusiasts during city tours."
    }
],



services: [
    {
        name: "12 Seater Tempo Traveller Pune Darshan",
        description:
            "Rising Cab Service offers 12 Seater Tempo Traveller Pune Darshan for small family groups and friends who want a comfortable sightseeing experience across Pune. Our well-maintained vehicles come with pushback seats, AC comfort, and experienced drivers who ensure a smooth travel experience covering temples, historical landmarks, gardens, and popular tourist attractions with flexible full-day or half-day packages."
    },
    {
        name: "13 Seater Tempo Traveller On Rent Pune",
        description:
            "Book 13 Seater Tempo Traveller On Rent Pune with Rising Cab Service for group travel, family tours, and corporate outings. Our tempo travellers are designed for comfort with spacious seating, air-conditioning, and professional drivers who ensure safe travel across Pune city and nearby destinations with customizable routes and affordable pricing."
    },
    {
        name: "17 Seater Tempo Traveller On Rent Pune",
        description:
            "Rising Cab Service provides 17 Seater Tempo Traveller On Rent Pune for medium-sized groups planning sightseeing tours, religious trips, or weekend getaways. Our vehicles are clean, well-maintained, and equipped with modern amenities to ensure a comfortable and hassle-free travel experience across Pune and surrounding tourist destinations."
    },
    {
        name: "20 Seater Tempo Traveller On Rent Pune",
        description:
            "Our 20 Seater Tempo Traveller On Rent Pune service is ideal for large family gatherings, corporate trips, and group tours. Rising Cab Service ensures spacious seating, AC comfort, and experienced drivers who make long-distance and local travel smooth, safe, and enjoyable with flexible booking options."
    },
    {
        name: "26 Seater Tempo Traveller On Rent Pune",
        description:
            "Rising Cab Service offers 26 Seater Tempo Traveller On Rent Pune for bigger groups seeking reliable transportation for sightseeing, weddings, and pilgrimage tours. Our tempo travellers provide ample legroom, comfortable seating, and professional drivers ensuring a stress-free journey across Maharashtra."
    },
    {
        name: "32 Seater Tempo Traveller On Rent Pune",
        description:
            "Book 32 Seater Tempo Traveller On Rent Pune with Rising Cab Service for large group travel including corporate tours, religious yatras, and family functions. Our vehicles are well-maintained with AC comfort and experienced chauffeurs ensuring safe and comfortable long-distance and local travel."
    },
    {
        name: "AC Tempo Traveller Rental Pune",
        description:
            "Rising Cab Service provides AC Tempo Traveller Rental Pune for comfortable group travel in all weather conditions. Our air-conditioned vehicles are perfect for sightseeing, airport transfers, and outstation trips, offering a smooth ride with professional drivers and flexible booking options."
    },
    {
        name: "Luxury Tempo Traveller Hire Pune",
        description:
            "Our Luxury Tempo Traveller Hire Pune service is designed for premium travel experiences with plush seating, advanced interiors, and superior comfort. Rising Cab Service ensures luxury group travel for corporate clients, weddings, and high-end tourism with top-quality service and professional chauffeurs."
    },
    {
        name: "Maharaja Tempo Traveller Pune",
        description:
            "Rising Cab Service offers Maharaja Tempo Traveller Pune for customers seeking ultra-luxury group travel. These vehicles come with premium seating, spacious interiors, and enhanced comfort features, making them perfect for long journeys, family celebrations, and VIP travel experiences."
    },
    {
        name: "Group Travel Tempo Traveller Pune",
        description:
            "Book Group Travel Tempo Traveller Pune with Rising Cab Service for convenient and economical transportation for large groups. Our tempo travellers are suitable for tours, corporate events, weddings, and pilgrimage trips with flexible routes and professional service."
    },
    {
        name: "Pune Darshan Tempo Traveller On Rent",
        description:
            "Rising Cab Service provides Pune Darshan Tempo Traveller On Rent for comfortable city sightseeing tours. Ideal for families and tourist groups, our service covers Pune’s major attractions including temples, forts, gardens, and heritage sites with experienced drivers and customizable itineraries."
    },
    {
        name: "Tempo Traveller for Pune Darshan",
        description:
            "Our Tempo Traveller for Pune Darshan service offers a convenient way to explore Pune in groups with comfort and flexibility. Rising Cab Service ensures clean vehicles, professional drivers, and well-planned sightseeing routes for a smooth city tour experience."
    },
    {
        name: "Pune Sightseeing Tempo Traveller",
        description:
            "Rising Cab Service provides Pune Sightseeing Tempo Traveller for tourists looking to explore the city’s famous landmarks and attractions. Our service includes flexible packages, comfortable seating, and experienced drivers for a memorable sightseeing experience."
    },
    {
        name: "Pune City Tour Tempo Traveller",
        description:
            "Book Pune City Tour Tempo Traveller with Rising Cab Service for a complete city exploration experience. Our vehicles are perfect for group travel with AC comfort, spacious seating, and professional drivers who ensure a smooth journey across Pune."
    },
    {
        name: "Pune Darshan Tempo Traveller Booking",
        description:
            "Rising Cab Service offers Pune Darshan Tempo Traveller Booking for easy and quick reservations for sightseeing tours. Customers can choose from multiple vehicle options and enjoy a comfortable journey across Pune’s top attractions with flexible timing."
    },
    {
        name: "Tempo Traveller Hire for Pune Darshan",
        description:
            "Our Tempo Traveller Hire for Pune Darshan service is ideal for families and tourist groups who want a relaxed city tour experience. Rising Cab Service ensures well-maintained vehicles, experienced drivers, and customizable sightseeing plans."
    },
    {
        name: "Pune Tourist Tempo Traveller",
        description:
            "Rising Cab Service provides Pune Tourist Tempo Traveller for visitors exploring Pune and nearby destinations. Our service ensures comfortable group travel with AC vehicles, professional drivers, and affordable tour packages."
    },
    {
        name: "Pune Local Sightseeing Tempo Traveller",
        description:
            "Book Pune Local Sightseeing Tempo Traveller with Rising Cab Service for a convenient and enjoyable city exploration experience. Our tempo travellers are perfect for family trips, group tours, and weekend outings across Pune."
    },
    {
        name: "Pune One Day Tour Tempo Traveller",
        description:
            "Rising Cab Service offers Pune One Day Tour Tempo Traveller for full-day sightseeing trips across Pune. Our service includes comfortable vehicles, experienced drivers, and well-planned itineraries covering major attractions in a single day."
    },
    {
        name: "Tempo Traveller Rental Pune",
        description:
            "Our Tempo Traveller Rental Pune service provides flexible booking options for all types of group travel including tourism, weddings, corporate trips, and pilgrimages. Rising Cab Service ensures comfort, safety, and affordability in every journey."
    },
    {
        name: "Pune Sightseeing Traveller Hire",
        description:
            "Rising Cab Service offers Pune Sightseeing Traveller Hire for tourists who want a comfortable and guided city tour experience. Our professional drivers and clean vehicles ensure a smooth journey across Pune’s major attractions."
    },
    {
        name: "Pune City Tour Traveller Rental",
        description:
            "Book Pune City Tour Traveller Rental with Rising Cab Service for group sightseeing tours across Pune. Our service includes spacious vehicles, flexible schedules, and experienced drivers for a hassle-free travel experience."
    }
],

tableData: [
    ["12 Seater Tempo Traveller Pune Darshan", "13 Seater Tempo Traveller On Rent Pune"],
    ["17 Seater Tempo Traveller On Rent Pune", "20 Seater Tempo Traveller On Rent Pune"],
    ["26 Seater Tempo Traveller On Rent Pune", "32 Seater Tempo Traveller On Rent Pune"],
    ["AC Tempo Traveller Rental Pune", "Luxury Tempo Traveller Hire Pune"],
    ["Maharaja Tempo Traveller Pune", "Group Travel Tempo Traveller Pune"],
    ["Pune Darshan Tempo Traveller On Rent", "Tempo Traveller for Pune Darshan"],
    ["Pune Sightseeing Tempo Traveller", "Pune City Tour Tempo Traveller"],
    ["Pune Darshan Tempo Traveller Booking", "Tempo Traveller Hire for Pune Darshan"],
    ["Pune Tourist Tempo Traveller", "Pune Local Sightseeing Tempo Traveller"],
    ["Pune One Day Tour Tempo Traveller", "Tempo Traveller Rental Pune"],
    ["Pune Sightseeing Traveller Hire", "Pune City Tour Traveller Rental"]
],



whychoose: [
    {
        WhyChooseheading: "Dedicated Pune Darshan Tempo Traveller Rental",
        WhyChoosedescription: "Rising Cab Service provides comfortable Tempo Traveller rentals for Pune Darshan, allowing groups to explore the city's famous historical, cultural, and religious attractions conveniently."
    },
    {
        WhyChooseheading: "Spacious Tempo Travellers for Group Tours",
        WhyChoosedescription: "Our well-maintained Tempo Travellers offer spacious seating, ample luggage space, and comfortable interiors, making them ideal for Pune sightseeing trips."
    },
    {
        WhyChooseheading: "Customized Pune Darshan Itineraries",
        WhyChoosedescription: "We offer flexible Pune Darshan travel plans that can be customized according to your preferred attractions, group size, and sightseeing schedule."
    },
    {
        WhyChooseheading: "Affordable Tempo Traveller Packages",
        WhyChoosedescription: "Rising Cab Service provides budget-friendly Pune Darshan Tempo Traveller packages with transparent pricing and excellent travel value."
    },
    {
        WhyChooseheading: "Visit Major Tourist Attractions",
        WhyChoosedescription: "Our Pune Darshan tours cover popular destinations including Shaniwar Wada, Aga Khan Palace, Dagdusheth Ganpati, Saras Baug, Lal Mahal, Pataleshwar Temple, and Sinhagad Fort."
    },
    {
        WhyChooseheading: "Experienced Drivers for City Tours",
        WhyChoosedescription: "Our professional drivers have extensive knowledge of Pune's tourist attractions and ensure smooth, safe, and efficient sightseeing journeys."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "We offer pickup services from Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Pune Airport, and surrounding areas."
    },
    {
        WhyChooseheading: "Perfect for Families, Friends & Corporate Groups",
        WhyChoosedescription: "Our Tempo Traveller rental service is ideal for family outings, tourist groups, school trips, corporate teams, and social gatherings exploring Pune."
    }
]
};

const faqData = [
    {
        question: "What is Pune Darshan Tempo Traveller on Rent?",
        answer: "It is a group travel service that provides Tempo Travellers on rent for sightseeing tours covering Pune's major tourist attractions."
    },
    {
        question: "Which places are included in Pune Darshan tours?",
        answer: "Popular attractions include Shaniwar Wada, Aga Khan Palace, Dagdusheth Ganpati, Saras Baug, Lal Mahal, Pataleshwar Temple, and Sinhagad Fort."
    },
    {
        question: "What seating capacities are available in Tempo Travellers?",
        answer: "We offer Tempo Travellers with seating capacities ranging from 12-seater to 20-seater options."
    },
    {
        question: "Can I customize my Pune Darshan itinerary?",
        answer: "Yes, Rising Cab Service provides customized sightseeing plans based on your preferred attractions and travel schedule."
    },
    {
        question: "Are Tempo Travellers suitable for family groups?",
        answer: "Yes, our Tempo Travellers are spacious and comfortable, making them ideal for family trips and group tours."
    },
    {
        question: "Do you provide pickup from Pune Airport?",
        answer: "Yes, pickup and drop services are available from Pune Airport, Railway Station, hotels, and residential locations."
    },
    {
        question: "Are AC Tempo Travellers available?",
        answer: "Yes, we provide fully air-conditioned Tempo Travellers for comfortable Pune sightseeing tours."
    },
    {
        question: "Can corporate groups hire Tempo Travellers for Pune Darshan?",
        answer: "Yes, our Tempo Traveller rental service is suitable for corporate outings, team events, and employee group tours."
    },
    {
        question: "How long does a Pune Darshan tour take?",
        answer: "A typical Pune Darshan tour usually takes between 6 to 10 hours depending on the selected attractions."
    },
    {
        question: "How can I book a Pune Darshan Tempo Traveller on Rent?",
        answer: "You can book your Tempo Traveller through phone, WhatsApp, or online booking with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nilesh Jagtap",
        feedback:
            "Our Pune Darshan group tour was extremely comfortable with Rising Cab Service. The Tempo Traveller was spacious, clean, and perfect for our family outing.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sonali Deshmukh",
        feedback:
            "The sightseeing experience was excellent from start to finish. The driver was knowledgeable about Pune attractions, and the Tempo Traveller provided great comfort for our entire group.",
        rating: 5
    }
];
















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune Darshan Tempo Traveller on Rent",
"image": "https://www.risingcabservice.com/assets/images/pune-darshan-tempo-traveller.jpg",
"description": "Book Pune Darshan Tempo Traveller on Rent with Rising Cab Service for group sightseeing, city tours, family trips, and corporate travel. Available in 12, 13, 17, 20, 26, and 32 seater options with AC comfort and professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-darshan-tempo-traveller-on-rent"
}
};






    return (
        <div>


<Helmet>
  <title>Pune Darshan Tempo Traveller on Rent | Group Tour Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune Darshan Tempo Traveller on Rent for group sightseeing, family tours, corporate trips, and city travel. Available in 12, 13, 17, 20, 26, and 32 seater AC tempo travellers."
/>

<meta
 name="keywords"
 content="12 Seater Tempo Traveller Pune Darshan, 13 Seater Tempo Traveller On Rent Pune, 17 Seater Tempo Traveller On Rent Pune, 20 Seater Tempo Traveller On Rent Pune, 26 Seater Tempo Traveller On Rent Pune, 32 Seater Tempo Traveller On Rent Pune, Pune Darshan Tempo Traveller On Rent, Tempo Traveller Pune sightseeing, Pune group travel tempo traveller, AC tempo traveller Pune hire, family tempo traveller Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punedarshantempotraveller;